import { Navigate } from 'react-router-dom';
export default function GPSTracking() {
  return <Navigate to="/supervisors" replace />;
}
